import { motion, useAnimation } from 'motion/react';
import React, { PropsWithChildren, useEffect } from 'react';

export const SafeMotionDiv = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<any>
>(({ children, ...props }, ref) => {
  const controls = useAnimation();

  useEffect(() => {
    return () => {
      controls.stop();
    };
  }, [controls]);

  return (
    <motion.div ref={ref} animate={controls} {...props}>
      {children}
    </motion.div>
  );
});
